export const ar = {
  // brand / general
  fast_online_tools: "أدوات أونلاين سريعة",
  choose_tool: "اختر الأداة",
  home: "الرئيسية",
  tools: "الأدوات",
  seo_content: "محتوى الأدوات",
  articles: "محتوى المقالات",
  article_categories: "تصنيفات المقالات",
  home_content: "محتوى الصفحة الرئيسية",
  learning_library: "المكتبة التعليمية",
  no_login_required: "مكتبة تعليمية • إرشادات خصوصية وحقوق",
  // downloader
  paste_url_here: "الصق الرابط هنا",
  analyze: "تحليل",
  analyzing: "جاري التحليل…",
  paste: "لصق",
  clear: "مسح",
  download: "تحميل",
  downloading: "جاري التحميل…",
  available_formats: "الصيغ والجودات المتاحة",
  audio_mp3: "صوت MP3",
  duration: "المدة",
  by: "بواسطة",
  how_it_works: "كيف تستفيد من الموقع؟",
  step_choose: "استكشف المكتبة التعليمية",
  step_paste: "راجع إرشادات الخصوصية",
  step_analyze: "تحقق من حقوق المحتوى",
  step_download: "استخدم خيارات المنصة الرسمية",
  // states
  platform_unavailable: "هذه المنصة غير متاحة حاليًا.",
  temporarily_unavailable: "غير متاح حاليًا",
  invalid_url: "الرابط غير صالح. تأكد من الرابط وحاول مرة أخرى.",
  try_again: "حاول مرة أخرى",
  no_media: "لم يتم العثور على وسائط قابلة للتحميل في هذا الرابط.",
  privacy_note: "لا نحتفظ بأي ملف. تتم المعالجة مؤقتًا ويُحذف الملف تلقائيًا بعد التسليم.",
  // nav / footer
  faq: "الأسئلة الشائعة",
  about: "من نحن",
  contact: "اتصل بنا",
  privacy: "سياسة الخصوصية",
  terms: "شروط الاستخدام",
  all_rights: "جميع الحقوق محفوظة",
  footer_tagline: "أدوات أونلاين سريعة وآمنة بدون تسجيل.",
  // admin
  admin_panel: "لوحة التحكم",
  login: "تسجيل الدخول",
  logout: "خروج",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  dashboard: "الإحصاءات",
  platforms: "المنصات",
  content: "المحتوى",
  ads: "الإعلانات",
  settings: "الإعدادات",
  logs: "السجلّات",
  save: "حفظ",
  saved: "تم الحفظ",
  cancel: "إلغاء",
  add: "إضافة",
  edit: "تعديل",
  delete: "حذف",
  enabled: "مفعّل",
  disabled: "معطّل",
  active: "نشط",
};

export default ar;
